import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class PushDataService extends ApiService {
  static pathName = '/push-data';

  static uploadRawFile = (body: {
    googleAccessToken: string;
    fileUrl: string;
    folderId: string;
    fileName?: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/upload-raw`, body);
  };

  static pushDataToGoogleSlides = (body: {
    googleAccessToken: string;
    requests: any[];
    presentationId: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/update-presentation`, body);
  };

  static pushDataToGoogleSheets = (body: {
    googleAccessToken: string;
    spreadsheetId: string;
    text: string;
    sheetName: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/push-data-to-sheet`, body);
  };

  static readonly pushMicrosoftExcelData = (body: {
    fileId: string;
    worksheetId: string;
    text: string;
    sheetName?: string;
    createNewSheet?: boolean;
  }): Promise<IGetOneResponse<{ success: boolean }>> => {
    return ApiService.post(
      `${this.pathName}/microsoft/push-excel-data`,
      body,
    );
  };

  static readonly pushMicrosoftWordData = (body: {
    fileId?: string;
    text: string;
    newDocumentName?: string;
    pushOption?: string;
    specifiedPage?: number;
  }): Promise<IGetOneResponse<{ success: boolean }>> => {
    return ApiService.post(
      `${this.pathName}/microsoft/push-word-data`,
      body,
    );
  };

  static readonly pushMicrosoftPowerPointData = (body: {
    fileId?: string;
    text: string;
    newPresentationName?: string;
    slideOption?: string;
  }): Promise<IGetOneResponse<{ success: boolean }>> => {
    return ApiService.post(
      `${this.pathName}/microsoft/push-powerpoint-data`,
      body,
    );
  };

  static readonly uploadMicrosoftRawFile = (body: {
    fileUrl: string;
    fileName?: string;
    folderId?: string;
  }): Promise<IGetOneResponse<{ success: boolean }>> => {
    return ApiService.post(
      `${this.pathName}/microsoft/upload-raw-file`,
      body,
    );
  };
}
